"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var FOLDERS_ENDPOINT = 'folders/v1/folders';

var FoldersAPI =
/*#__PURE__*/
function () {
  function FoldersAPI() {
    (0, _classCallCheck2.default)(this, FoldersAPI);
  }

  (0, _createClass2.default)(FoldersAPI, null, [{
    key: "create",
    value: function create(_ref) {
      var type = _ref.type,
          folder = _ref.folder;
      return _apiClient.default.post(FOLDERS_ENDPOINT + "/" + type, {
        data: folder.toJS()
      });
    }
  }, {
    key: "update",
    value: function update(_ref2) {
      var type = _ref2.type,
          folder = _ref2.folder;
      var folderId = folder.folderId;
      return _apiClient.default.put(FOLDERS_ENDPOINT + "/" + type + "/" + folderId, {
        data: folder.toJS()
      });
    } // TODO: Swap this endpoint or add a new one

  }, {
    key: "remove",
    value: function remove(_ref3) {
      var type = _ref3.type,
          folderId = _ref3.folderId;
      return _apiClient.default.delete(FOLDERS_ENDPOINT + "/" + type + "/" + folderId);
    }
  }]);
  return FoldersAPI;
}();

exports.default = FoldersAPI;
module.exports = exports.default;